module.exports = __webpack_public_path__ + "files/b1b6007da3940f07ec432b283fe640b6.png";